module.exports = __webpack_public_path__ + "static/media/spot6.9d20b138.webp";